import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { RecoilRoot, useRecoilState } from "recoil";
import "react-rangeslider/lib/index.css";
import "semantic-ui-css/semantic.min.css";

import { VERSION } from "./features";
import { isConfig, params } from "./params";

import "./index.css";
import * as serviceWorker from "./serviceWorker";

import { currentPlaylistUrl } from "./atoms";

import { Albums } from "./Albums";
import { Player } from "./Player";
import { Config } from "./Config";
import { listAddress } from "./api";

console.info(`${VERSION.name} version ${VERSION.version}`);

function Main() {
  const [playlistUrl, setPlaylistUrl] = useRecoilState(currentPlaylistUrl);

  const list = global.features.defaultList
    ? "default"
    : params("list", undefined);

  useEffect(() => {
    if (playlistUrl === null) {
      setPlaylistUrl(listAddress(list));
    }
  }, [list, playlistUrl, setPlaylistUrl]);

  return list ? <Player /> : <Albums />;
}

ReactDOM.render(
  <React.StrictMode>
    {isConfig() ? (
      <Config />
    ) : (
      <RecoilRoot>
        <Main />
      </RecoilRoot>
    )}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
